/**
 * Converts date-posted elements to compact relative time (e.g. "3s", "3m", "3h", "3d").
 * Expects data-date-posted in YYYY-MM-DD or YYYY-MM-DDTHH:MM format.
 */
function formatRelativeTime(dateStr) {
  if (!dateStr || !dateStr.trim()) return null;
  let date;
  if (dateStr.includes('T') || dateStr.includes(' ')) {
    date = new Date(dateStr);
  } else {
    date = new Date(dateStr + 'T00:00:00');
  }
  if (Number.isNaN(date.getTime())) return null;
  const now = new Date();
  const diffMs = now - date;
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffSeconds < 0) {
    return dateStr;
  }
  if (diffSeconds < 60) {
    return `${diffSeconds}s`;
  }
  if (diffMinutes < 60) {
    return `${diffMinutes}m`;
  }
  if (diffHours < 24) {
    return `${diffHours}h`;
  }
  if (diffDays < 7) {
    return `${diffDays}d`;
  }
  if (diffWeeks < 4) {
    return `${diffWeeks}w`;
  }
  if (diffMonths < 12) {
    return `${diffMonths}mo`;
  }
  return `${diffYears}y`;
}

function initRelativeTime() {
  const elements = document.querySelectorAll('.social-content__author-date[data-date-posted]');
  for (const el of elements) {
    const dateStr = el.dataset.datePosted?.trim();
    const relative = formatRelativeTime(dateStr || '');
    if (relative === null) continue;
    el.textContent = relative;
    el.dataset.processed = 'true';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRelativeTime);
} else {
  initRelativeTime();
}

document.addEventListener('shopify:section:load', initRelativeTime);
